import moment from 'moment'

const momentHelper = {
  getMoment (date) {
    let cache = momentHelper[date]
    if (cache) return cache
    return moment(date)
  }
}

class UserTaskParser {
  constructor (items, sdate, startDate, endDate) {
    this.sdate = sdate
    this.items0 = items
    this.total = items.length
    this.dates = this._getDates(startDate, endDate)
    // this._parse()
    this.items = this._groupTasks()
  }
  _parse () {
    let items = this.items0
    items.forEach((obj, idx) => {
      let sdate1 = momentHelper.getMoment(obj.sdate)
      let d = sdate1.isoWeekday()
      // fix duration
      // let duration = Math.min((7 - d + 1), obj.duration)
      let duration =  obj.duration;
      // caculate the next date of end date
      sdate1.add(duration, 'days')
      obj.edate = sdate1.format('YYYY-MM-DD')
      obj.duration = duration
      obj.weekday = d
      obj.space = obj.duration
      obj.canHasFollowingTasks = this.dates.includes(obj.edate)
    })
    this.items0 = items.sort((a, b) => a.weekday - b.weekday)
  }

  /***
   *
   * @returns {Array}
   * @private
   *
   * startdate 传入的开始时间
   * enddate 传入的结束时间
   * num 时间差
   */
  _getDates (startDate, endDate) {
    // let now = momentHelper.getMoment(this.sdate)
    //时间转换为 moment 格式的日期
    let startdate = moment(startDate)
    let enddate = moment(endDate)
    // let num = enddate.diff(startdate, 'days')
    //获取 月份
    let startMonth = (new Date(startdate).getMonth())
    let endMonth = (new Date(enddate).getMonth())
    //获取年份
    let startYear = (new Date(startdate).getFullYear());
    let endYear = (new Date(enddate).getFullYear());

    //如果时间格式跨年，那么月份就要加上这段空白期
    // 比如： 2019-02-01 到 2021-02-01  那么就要加24个月
    if(startYear < endYear){
      endMonth = ( endYear - startYear) * 12 + endMonth;
      // console.log(endMonth)
    }

    let ret = []
    let dayStart = (new Date(startdate).getDate())
    let j2 = startMonth; //这个参数用于解决 moment.month()里的值大于12的时候，年份会一直增加
    for (let j = startMonth; j <= endMonth; j++) {
      if(j2 === 13){
        j2 = 1;
        startdate = startdate.month(j2)
      }
      startdate.month(j2);
      j2 ++;
      let num = startdate.daysInMonth()
      for (let i = dayStart; i <= num; i++) {
        // console.log(i)
        // console.log(`${startdate.date(i)}`, i,  "_getDates_getDates_getDates_getDates_getDates");
        let res = startdate.date(i).format('YYYY-MM-DD')

        ret.push(res)
      }
      dayStart = 1;

    }
    console.log(ret,'ret')
    // console.log(startdate.date(33).format('MM-DD'))
    return ret
  }
  _getNextDateOf (date) {
    let idx = this.dates.findIndex(obj => obj === date)
    if (idx === (this.dates.length - 1)) return null
    return this.dates[idx + 1]
  }
  _getFollowingTask (items, date, space, matchedItems) {
    if (space === 0 || date === null) {
      return matchedItems
    }
    let tasks = items.filter((item) => {
      return (item.sdate === date && item.duration <= space)
    })
    tasks.sort((a, b) => (b.duration - a.duration))
    let rawIdx = null
    let task = null
    if (tasks.length > 0) {
      task = tasks[0]
      rawIdx = items.findIndex((item) => {
        return item._id === task._id
      })
      // remove the selected task
      items.splice(rawIdx, 1)
      matchedItems.push(task)
      if (!task.canHasFollowingTasks) return matchedItems
      return this._getFollowingTask(items, task.edate, task.space, matchedItems)
    }
    return this._getFollowingTask(items, this._getNextDateOf(date), space - 1, matchedItems)
  }
  _groupTasks () {
    let items = this.items0.slice()
    items = items.sort((a,b) => {
      return b.sdate > a.sdate;
    })
    let rows = [];
    for(let i in items){

    // console.log(this.items0, "sss")
      /**
       * 这里原作者使用while循环，会导致部分数据被删除, 改成for循环后正常
       * */
    // while (items.length) {
      let obj = items[i]
      let row = {
        sdate: obj.sdate
      }
      row[obj.sdate] = obj
      if (!obj.canHasFollowingTasks) {
        rows.push(row)
        continue
      }
      let followingTasks = []
      this._getFollowingTask(items, obj.edate, obj.space, followingTasks)
      followingTasks.forEach((obj1, idx1) => {
        row[obj1.sdate] = obj1
      })
      rows.push(row)
    }
    // console.log(rows, "dddd");

    return rows
  }
}

export default UserTaskParser
